/* eslint-disable no-mixed-spaces-and-tabs */
import { Box, Card, CircularProgress, Stack } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useFeatureFlagContext } from '@/context/featureFlagContext';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { paths } from '@/app/routes';
import PipelineSelect from '@/components/selects/PipelineSelect';
import DealStageTable from '@/components/tables/DealStageTable';
import { usePipelineContext } from '@/context/pipelineContext';
import { BrokerComplianceStepsTable } from '@/components/tables/BrokerComplianceStepsTable';

export const EditPipelinesView = () => {
	const navigate = useNavigate();

	const [pipelineId, setPipelineId] = useState(process.env.REACT_APP_PIPELINE_NEW_BUSINESS);

	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;
	const { data: userDetails } = useGetUserDetailsQuery({ email }, { skip: !email });

	const { getFeatureFlags, isLoading } = useFeatureFlagContext();
	const showProfile = Boolean(getFeatureFlags('profile')?.active);
	const editStageLabels = Boolean(getFeatureFlags('editStageLabels')?.active);
	const brokerComplianceSteps = Boolean(getFeatureFlags('brokerComplianceSteps')?.active);

	const canViewStageTable = useMemo(
		() => editStageLabels && userDetails?.principleUser,
		[userDetails?.principleUser, editStageLabels],
	);

	const { pipeline } = usePipelineContext(pipelineId);
	const isProspectsPipeline = useMemo(() => {
		const name = pipeline?.label ?? pipeline?.pipelineName ?? '';
		return name.toLowerCase().includes('prospect');
	}, [pipeline]);

	useEffect(() => {
		if (!isLoading && !canViewStageTable) {
			navigate(showProfile ? `${paths.settings}/user` : paths.home);
		}
	}, [isLoading, canViewStageTable, showProfile, navigate]);

	return (
		<>
			{isLoading ? (
				<CircularProgress />
			) : canViewStageTable ? (
				<Stack sx={{ padding: 1 }} spacing={1}>
					<Box
						width='25%'
						sx={{
							'& .MuiInputBase-root': { height: '32px' },
							'& .MuiAutocomplete-input': { padding: '0px !important' },
						}}
					>
						<PipelineSelect
							value={pipelineId}
							onChange={(v) => setPipelineId(v)}
							hideProspectStage={false}
						/>
					</Box>

					<DealStageTable pipelineId={pipelineId} />

					{!isProspectsPipeline && brokerComplianceSteps && (
						<Box sx={{ mt: 6 }}>
							<BrokerComplianceStepsTable pipelineId={pipelineId} />
						</Box>
					)}
				</Stack>
			) : (
				<></>
			)}
		</>
	);
};
